/**
 * services/_demo/verticalStore.ts
 * Module-level holder for the demo vertical, kept in sync by AppContext. Lets
 * the seed-fallback services serve the right dataset without threading the
 * vertical through every call. No effect in production (the live API answers
 * first; the fallback only runs when the backend is unreachable).
 */
export type DemoVertical = 'restaurant' | 'fashion' | 'construction';

let current: DemoVertical = 'restaurant';

export const setDemoVertical = (v: DemoVertical): void => {
  current = v;
};

export const getDemoVertical = (): DemoVertical => current;
